
// ────── Web : mock modulaire 100 % compatible avec ton code ──────
const mockAnalytics = {
  logEvent: async (analyticsRef, name, params) => {
    console.debug('[Firebase Analytics:mock] logEvent →', name, params || '');
    return Promise.resolve();
  },
  setUserId: async (analyticsRef, userId) => {
    console.debug('[Firebase Analytics:mock] setUserId →', userId);
    return Promise.resolve();
  },
  setUserProperties: async (analyticsRef, properties) => {
    console.debug('[Firebase Analytics:mock] setUserProperties →', properties);
    return Promise.resolve();
  },
  setCurrentScreen: async (analyticsRef, screenName) => {
    console.debug('[Firebase Analytics:mock] setCurrentScreen →', screenName);
    return Promise.resolve();
  },
  setAnalyticsCollectionEnabled: async (analyticsRef, enabled) => {
    console.debug('[Firebase Analytics:mock] collectionEnabled →', enabled);
    return Promise.resolve();
  },
};

// getAnalytics() → retourne un objet "référence" (même si c'est un mock)
const analyticsRef = {};

export const getAnalytics = () => {
  console.debug('[Firebase Analytics:mock] getAnalytics() appelé');
  return analyticsRef;
};

// Export des fonctions modulaires (exactement comme le vrai SDK)
export const logEvent = (ref, name, params) => mockAnalytics.logEvent(ref, name, params);
export const setUserId = (ref, userId) => mockAnalytics.setUserId(ref, userId);
export const setUserProperties = (ref, properties) => mockAnalytics.setUserProperties(ref, properties);
export const setCurrentScreen = (ref, screenName) => mockAnalytics.setCurrentScreen(ref, screenName);
export const setAnalyticsCollectionEnabled = (ref, enabled) => mockAnalytics.setAnalyticsCollectionEnabled(ref, enabled);

// Export par défaut (au cas où)
export default {
  getAnalytics,
  logEvent,
  setUserId,
  setUserProperties,
  setCurrentScreen,
  setAnalyticsCollectionEnabled,
};

// Compatibilité require()
if (typeof module !== 'undefined') {
  module.exports = {
    getAnalytics,
    logEvent,
    setUserId,
    setUserProperties,
    setCurrentScreen,
    setAnalyticsCollectionEnabled,
    default: { getAnalytics },
  };
}